<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['SMB']['GMC']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <!--
    <div class='searchCol'>
        <span class='searchLabel80'>{{this.getLanguage["DM"]["AGI"]}} :</span>
        <treeselect :multiple="false"
                    :options="dd_agentgroup"
                    :defaultExpandLevel="Infinity"
                    :placeholder="this.utilGetDDLanguage('DM.AGI')" />v-model="arr_FV['AGI']"
    </div>
    -->

                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroup"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            :load-options="loadAgentGroupOptions"
                                            v-model="searchAgentGroup"
                                            @input="AgentGroupChangefs" />
                                <span class="ErrMsg"></span>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GAME']['CAT']}}</span>
                                <treeselect :multiple="false"
                                            :load-options="loadCategoryOptions"
                                            :options="ddCategoryList"
                                            :placeholder="this.utilGetDDLanguage('GAME.CAT')"
                                            :auto-load-root-options="false"
                                            @input="CategoryNameChange"
                                            v-model="searchCategory" />
                                <span class="ErrMsg"></span>
                            </div>
                            <div class='searchCol'>
                                <span class="searchLabel">{{this.getLanguage["GAME"]["PROV"]}}<span class="required" /> :</span>
                                <treeselect :multiple="false"
                                            :options="ddProviderList"
                                            :auto-load-root-options="false"
                                            :placeholder="this.utilGetDDLanguage('GAME.PROV')"
                                            :load-options="loadProviderOptions"
                                            v-model="searchProvider" />
                                <span class="ErrMsg">{{ ValidationErrMsg('GP') }}</span>
                            </div>
                            <div class="searchCol">
                                <span class="searchLabel">{{getLanguage["GMC"]["GSB"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="brandStatus"
                                            placeholder
                                            v-model="searchBRS" />
                                <span class="ErrMsg"></span>
                            </div>
                            <div class="searchCol">
                                <span class="searchLabel">{{getLanguage["GMC"]["GSD"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="gameStatus"
                                            placeholder
                                            v-model="searchRS" />
                                <span class="ErrMsg"></span>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MTA"]["C"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('MTA.C')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            v-model="searchCurrency"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                                <span class="ErrMsg"></span>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage['GAME']['GL']}}</strong>
                    <div>
                        <div v-if="!noData">
                            <CButton class='searchBtn' size="sm" color="info" @click="resetCheckBoxState()"><span>{{this.getLanguage["BTN"]["RS"]}}</span></CButton>&nbsp;
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class='searchBtn' size="sm" color="info" @click="SaveSetting()"><span>{{this.getLanguage["BTN"]["SV"]}}</span></CButton>
                        </div>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage['GL']['NO']}}</th>
                                <th>{{ this.getLanguage["GMC"]["EGFB"] }}<span v-if="!noData" class="float-right"><input type="checkbox" v-model="selectAllBrands" class="selectALL checkBox15" /></span></th>
                                <th>{{ this.getLanguage["GMC"]["EGFD"] }}<span v-if="!noData" class="float-right"><input type="checkbox" v-model="selectAllDomains" class="selectALL checkBox15" /></span></th>
                                <th>{{ this.getLanguage["DM"]["L"] }}</th>
                                <th>{{ this.getLanguage["DM"]["C"] }}</th>
                                <th>{{ this.getLanguage["BAL"]["LU"] }}</th>
                                <th>{{ this.getLanguage["CPR"]["UB"] }}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage['GL']['NO']}}</th>
                                <th>{{ this.getLanguage["GMC"]["EGFB"] }}<span v-if="!noData" class="float-right"><input type="checkbox" v-model="selectAllBrands" class="selectALL checkBox15" /></span></th>
                                <th>{{ this.getLanguage["GMC"]["EGFD"] }}<span v-if="!noData" class="float-right"><input type="checkbox" v-model="selectAllDomains" class="selectALL checkBox15" /></span></th>
                                <th>{{ this.getLanguage["DM"]["L"] }}</th>
                                <th>{{ this.getLanguage["DM"]["C"] }}</th>
                                <th>{{ this.getLanguage["BAL"]["LU"] }}</th>
                                <th>{{ this.getLanguage["CPR"]["UB"] }}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="!arr_GameList || arr_GameList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_GameList" ref="mainTableData">
                            <td :rowspan="checkColSpan(data.PC)" v-if="showFirstRow(data.GN + '(' + data.PC + ')')" :class="CountCurrentRowNum() % 2 == 0 ? 'oddClass' : 'evenClass' ">{{CountItemByPC()}}</td>
                            <td :rowspan="checkColSpan(data.PC)" v-if="showFirstRow(data.GN + '(' + data.PC + ')')" :class="CountItemByRow()">{{showOne(data.GN + "(" + data.PC + ")")}}<span v-if="checkModuleAccess2(constAccessType.view)" class="float-right chkPadding"><input class="checkBox15" v-model="obj_Post.SelectedBrands" type="checkbox" @change="checkDomain($event, data.AGI)" :value="data.AGI" number /></span><span v-else></span></td>
                            <td :class="CountItemByRow()">{{ data.DN }}<span v-if="checkModuleAccess2(constAccessType.view)" class="float-right chkPadding"><input :class="renderClass(data.AGI)" type="checkbox" name="domainIds" :disabled="renderDisable(data.EGFB)" v-model="obj_Post.SelectedDomains" :value="data.I" number /></span><span v-else></span></td>
                            <td :class="CountItemByRow()">{{ data.L }}</td>
                            <td :class="CountItemByRow()">{{ data.CC }}<input type="hidden" value="data.GPI" v-model="obj_Post.OriginalData.GPI_CSV" :id="data.I"></td>
                            <td :class="CountItemByRow()">{{ formatDateTime(data.MCUTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td :class="CountItemByRow()">{{ data.MCUB }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import { required } from "vuelidate/lib/validators";
    import { constAccessType, constStatus, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                bool_showSearchBar: true,
                str_FV: "", //Filter Value
                searchCategory: null,
                searchProvider: null,
                searchCurrency: null,
                searchBRS: null,
                searchRS: null,
                searchAgentGroup: null,
                ddCategoryList: null,
                brandStatus: [],
                gameStatus: [],
                ddProviderList: null,
                dd_agentgroup: null,
                arr_GameList: [],
                dd_currency: [],
                noData: true,
                obj_Post: {
                    SelectedBrands: [],
                    SelectedDomains: [],
                    OriginalData: [
                        {
                            ID: null,
                            BrandID: null,
                            GPI_CSV: null,
                            AGPI_CSV: null
                        },
                    ],
                    SGPI: null,
                    SAGI: null,
                },
                original_data: {
                    SelectedBrands: [],
                    SelectedDomains: [],
                },
                constAccessType: constAccessType
            }
        },
        methods: {
            checkModuleAccess2(type) {
                return this.checkModuleAccess('GMC', 'GS', type);
            },
            newSearch() {
                this.$refs.search.focus();
                this.getGameList();
            },
            CountItemByPC() {
                return count++;
            },
            CountCurrentRowNum() {
                return count;
            },
            CountItemByRow(value = 0) {
                count = count + value;
                if ((count % 2) == 0) {
                    return "evenClass";
                }
                else {
                    return "oddClass";
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getGameList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }
                } else {
                    this.searchPAgi = 0;
                    this.searchAgentGroup = null;
                }
                this.searchCurrency = null;
                this.dd_currency = null;
                this.getCurrencyList();
            },
            loadCategoryOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/gameCat`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderCategory(d.dropdownlist[i].id);
                            }
                            that.ddCategoryList = d.dropdownlist;
                        }
                        else {
                            that.ddCategoryList = null;
                        }

                        callback();
                    });
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            CategoryNameChange(value) {

                this.ddProviderList = null;
                this.searchProvider = null;

                if (value != undefined && value > 0) {
                    var that = this;

                    this.getDataApi(`/api/dd/gameProvByCatId/` + value,

                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                for (var i = 0; i < d.dropdownlist.length; i++) {
                                    d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                                }

                                that.ddProviderList = d.dropdownlist;
                            }
                            else {
                                that.ddProviderList = null;
                            }
                        });

                }
            },
            loadProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/gameProv/`,

                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                            }

                            that.ddProviderList = d.dropdownlist;
                        }
                        else {
                            that.ddProviderList = null;
                        }

                        callback();
                    });
            },
            loadAgentGroupOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_agentgroup = d.dropdownlist;
                        }
                        else {
                            that.dd_agentgroup = null;
                        }
                        callback();
                    });
            },
            checkStatus(RS) {
                return this.$parent.checkStatus(RS);
            },
            updateGame(index) {
                this.bool_fullLoading = true;
                var that = this;
                this.arr_GameList[index].RS = this.arr_GameList[index].RS == 2 ? 1 : 2;

                this.postDataApi(`/api/game/s`, this.arr_GameList[index],
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            that.arr_GameList[index].UTS = d.UTS;
                        }
                        else {
                            that.getGameList();
                        }
                    });
            },
            renderGameName(providerName, gameName) {
                if (providerName in this.getLanguage && gameName in this.getLanguage[providerName])
                    return this.getLanguage[providerName][gameName];
                else
                    return gameName;
            },
            showOne(str) {
                if (temp != str) {
                    temp = str;
                    return str;
                }
                return "";
            },
            showFirstRow(str) {
                if (temp != str) {
                    return true;
                }
                return false;
            },
            generateRowCount(data) {
                if (data.length > 0) {
                    map = new Map();
                    count = 1;
                    data.forEach(function (value) {
                        if (map.has(value.PC)) {
                            var count = map.get(value.PC);
                            count++;
                            map.set(value.PC, count);
                        } else {
                            map.set(value.PC, 1);
                        }
                    });
                }
            },
            checkColSpan(str) {
                return map.get(str);
            },
            renderClass(agi) {
                return agi + ' checkBox15';
            },
            renderDisable(bool) {
                var TF = false;
                if (bool == 0) {
                    TF = true;
                }
                return TF;
            },
            checkDomain: function (e, agi) {
                var that = this;
                var inputs = document.getElementsByClassName(agi);
                var selectedDomain = that.obj_Post.SelectedDomains;
                if (e.target.checked == false) { // not checked
                    for (var i = 0, l = inputs.length; i < l; i++) {
                        inputs[i].checked = false;
                        inputs[i].disabled = true;
                        for (var j = 0; j < selectedDomain.length; j++) {
                            if (selectedDomain[j] == inputs[i].value) {
                                this.$delete(selectedDomain, j);
                            }
                        }
                    }
                }
                else { // checked
                    for (var i = 0, l = inputs.length; i < l; i++) {
                        inputs[i].disabled = false;
                    }
                }
            },
            resetAllCheckBox() {
                var that = this;
                var inputs = document.getElementsByName('domainIds');
                for (var i = 0, l = inputs.length; i < l; i++) {
                    inputs[i].disabled = false;
                }
            },
            setOriginalData() {
                var that = this;
                var OriginalData = [];
                that.arr_GameList.forEach(function (arr_GameList) {
                    OriginalData.push({ "ID": arr_GameList.I, "BrandID": arr_GameList.AGI, "GPI_CSV": arr_GameList.GPI, "AGPI_CSV": arr_GameList.AGL });
                });
                that.obj_Post.OriginalData = [...new Set(OriginalData)];
            },
            isDomainCheck() {
                var that = this;
                var SelectedDomains = [];

                that.arr_GameList.forEach(function (arr_GameList) {
                    if (arr_GameList.EGFD == 1) {
                        SelectedDomains.push(arr_GameList.I);
                    }
                });

                that.original_data.SelectedDomains = [...new Set(SelectedDomains)];
                that.obj_Post.SelectedDomains = [...new Set(SelectedDomains)];
            },
            isBrandCheck() {
                var that = this;
                var SelectedBrands = [];
                var obj = {
                    target: { checked: false }
                };

                that.arr_GameList.forEach(function (arr_GameList) {
                    var inputs = document.getElementsByClassName(arr_GameList.AGI);

                    if (arr_GameList.EGFB == 1) {
                        SelectedBrands.push(arr_GameList.AGI);
                        for (var x = 0, l = inputs.length; x < l; x++) {
                            inputs[x].disabled = false;
                        }
                    }
                    else {
                        for (var i = 0, l = inputs.length; i < l; i++) {
                            inputs[i].checked = false;
                            inputs[i].disabled = true;
                        }
                    }
                });
                that.original_data.SelectedBrands = [...new Set(SelectedBrands)];
                that.obj_Post.SelectedBrands = [...new Set(SelectedBrands)];
            },
            resetCheckBoxState() {
                var that = this;

                var inputs = document.getElementsByClassName('selectALL');
                for (var i = 0, l = inputs.length; i < l; i++) {
                    inputs[i].checked = false;

                }

                this.resetAllCheckBox();

                that.obj_Post.SelectedBrands = that.original_data.SelectedBrands;
                that.obj_Post.SelectedDomains = that.original_data.SelectedDomains;

                this.isBrandCheck();
                this.isDomainCheck();
            },
            SaveSetting() {
                this.bool_CV = true;
                this.$v.searchProvider.$touch();
                if (!this.$v.searchProvider.$error) {

                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;
                    this.postDataApi(`/api/game/sgmc`, this.obj_Post,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                that.getGameList();
                            }

                        });
                }
            },
            getGameList() {
                this.bool_CV = true;
                var that = this;
                var hasDefaultPath = false;
                var path = '';

                if (path) {
                    hasDefaultPath = true;
                }
                if (this.searchAgentGroup) {
                    path += ("&f.SAGI=" + this.searchAgentGroup);
                }
                if (this.searchProvider) {
                    path += ("&f.GPI=" + this.searchProvider);
                    this.obj_Post.SGPI = this.searchProvider;
                }
                if (this.searchBRS) {
                    path += ("&f.BRS=" + this.searchBRS);
                }
                if (this.searchRS) {
                    path += ("&f.RS=" + this.searchRS);
                }
                if (this.searchCurrency) {
                    path += ("&f.CC_csv=" + this.searchCurrency.join(','));
                }
                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                this.$v.searchProvider.$touch();
                if (!this.$v.searchProvider.$error) {

                    that.noData = true;
                    this.bool_fullLoading = true;

                    this.getDataApi(`/api/game/lgpi?${path}`,
                        function (d, s) {
                            that.bool_fullLoading = false;

                            if (s) {
                                that.arr_GameList = d.D.Items;
                                if (d.D.Items !== null) {
                                    if (d.D.Items.length > 0) {
                                        that.generateRowCount(d.D.Items);
                                        that.noData = false;
                                        that.isBrandCheck();
                                        that.isDomainCheck();
                                        that.setOriginalData();
                                        that.bool_CV = false;
                                        that.resizeTableHead();
                                    }
                                }
                            }
                        });
                }

            },
            ValidationErrMsg(langKey = "") {
                if (this.bool_CV) {
                    var validateObj = this.$v.searchProvider;
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["CMS"][langKey]);
                    }
                }

            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;
                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency2/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_currency = d.dropdownlist;
                            for (var i = 0; i < that.dd_currency.length; i++) {
                                that.dd_currency[i].id = that.dd_currency[i].label;
                            }
                        }
                    });
            },

        },
        validations: {
            searchProvider: { required }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess']),

            selectAllBrands: {
                get: function () {
                    return this.arr_GameList ? this.obj_Post.SelectedBrands.length == this.arr_GameList.length : false;
                },
                set: function (value) {
                    var SelectedBrands = [];
                    var SelectedDomains = [];
                    var inputs = document.getElementsByName('domainIds');
                    if (value) {
                        this.arr_GameList.forEach(function (arr_GameList) {
                            SelectedBrands.push(arr_GameList.AGI);
                        });
                        for (var i = 0, l = inputs.length; i < l; i++) {
                            inputs[i].disabled = false;
                        }
                    }
                    else {
                        for (var i = 0, l = inputs.length; i < l; i++) {
                            inputs[i].checked = false;
                            inputs[i].disabled = true;
                        }
                        this.obj_Post.SelectedDomains = [...new Set(SelectedDomains)];
                    }

                    this.obj_Post.SelectedBrands = [...new Set(SelectedBrands)];
                }
            },
            selectAllDomains: {

                get: function () {
                    return this.arr_GameList ? this.obj_Post.SelectedDomains.length == this.arr_GameList.length : false;
                },
                set: function (value) {
                    var SelectedDomains = [];
                    var inputs = document.getElementsByName('domainIds');

                    if (value) {
                        this.arr_GameList.forEach(function (arr_GameList) {
                            for (var i = 0, l = inputs.length; i < l; i++) {
                                if (!inputs[i].disabled) {
                                    SelectedDomains.push(inputs[i].value);
                                }
                            }
                        });
                    }
                    this.obj_Post.SelectedDomains = [...new Set(SelectedDomains)];
                }
            },
        },
        created() {
            this.$parent.showSubMenu = 'GS';
            this.$parent.showActiveMenu = 'GS.GMC';
            this.gameStatus = [{
                id: "1",
                label: this.getLanguage['GL']['DISB']
            }, {
                id: "2",
                label: this.getLanguage['GL']['ENB']
            }];
            this.brandStatus = [{
                id: "1",
                label: this.getLanguage['GL']['DISB']
            }, {
                id: "2",
                label: this.getLanguage['GL']['ENB']
            }];
            this.getCurrencyList();

            // this.getGameList();
        },
        updated: function () {
            var ref = this;
            this.$nextTick(function () {
                if (typeof ref.$refs.mainTableData != 'undefined') {
                    count = 1;
                    temp = "";
                }
            })
        },
        watch: {
            searchProvider: function (newData, oldData) {
                if (newData != oldData) {
                    this.arr_GameList = [];
                    this.noData = true;
                }
            },
            getLanguage() {
                this.getGameList();
            },
        },


    }
    var temp = "";
    var map;
    var count = 1;

</script>
<style>
    .evenClass {
        vertical-align: middle !important;
        background: #FFFFCC;
    }

    .oddClass {
        vertical-align: middle !important;
        background: #FFFFFF;
    }

    .greyClass {
        background: #ced2d8;
    }

    .chkPadding {
        padding: 0.25rem !important;
    }

    .checkBox15 {
        width: 15px;
        height: 15px;
        cursor: pointer;
    }
</style>




// WEBPACK FOOTER //
// src/components/SideMenu/GameSettings/GameMassConfig.vue